import { createDocumentStore } from "./documentStore";
import { createAuthApi } from "../../worker/client/authApi";
import { createProjectApi } from "../../worker/client/projectApi";

// Override with VITE_AEE_API_URL=http://localhost:8787 for local Worker development.
export const apiBase = (
  import.meta.env?.VITE_AEE_API_URL || "https://api.aldapasystems.com"
).replace(/\/$/, "");
export const authApi = createAuthApi(apiBase);
export const projectApi = createProjectApi(apiBase, async (url, init) => {
  const response = await authApi.transport(url, init);
  if (response.status === 401) {
    documentStore.clearPrefetch?.();
    window.dispatchEvent(new Event("aee-session-expired"));
  }
  return response;
});
export const syncTiming = { local: 1500, cloud: 15000 };

export const documentStore = createDocumentStore(projectApi);

// Production cookies belong to the cloud site; a localhost preview cannot borrow them.
export function isCloudPreview() {
  return (
    typeof window !== "undefined" &&
    ["localhost", "127.0.0.1", "[::1]"].includes(window.location.hostname) &&
    new URL(apiBase, window.location.origin).hostname ===
      "api.aldapasystems.com"
  );
}
